import "../assets/stylesheets/profile.css";
import { useAuth } from "../context/AuthContext.jsx";
import { useEffect, useState } from "react";

export default function Profile() {
    const [firstLoad, setFirstLoad] = useState(true);
    const { user } = useAuth();
    const [currentTrack, setCurrentTrack] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!user?.uid) return;

        const fetchCurrentlyPlaying = async () => {
            setLoading(true);
            try {
                const res = await fetch("/api/spotify/playing", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ uid: user.uid }),
                });

                const data = await res.json();
                if (data.playing) {
                    setCurrentTrack(data.track);
                } else {
                    setCurrentTrack(null);
                }
            } catch (err) {
                console.error("Failed to fetch currently playing track:", err);
                setCurrentTrack(null);
            } finally {
                setLoading(false);
                setFirstLoad(false)
            }
        };

        fetchCurrentlyPlaying();

        // Optional: poll every 30s for live updates
        const interval = setInterval(fetchCurrentlyPlaying, 5000);
        return () => clearInterval(interval);
    }, [user?.uid]);

    return (
        <div className="profileContainer">
            <h1 className="profileTitle">Your Profile</h1>
            <div className="profileInfo">
                <div className="profileAvatar">
                    <img src={user?.photoURL} alt="Profile" />
                    {user?.displayName}
                </div>
                <div className="profileStats">
                    <div className="profileCurrentlyListeningTitle">Currently listening to</div>
                    <div className="profileGetCurrentListening">
                        {loading && firstLoad
                            ? "Loading..."
                            : currentTrack
                                ? currentTrack.currently_playing_type == "track"
                                    ? <>
                                    <div className="trackContainer">
                                        <div className="trackCover">
                                            <img src={currentTrack.item.album.images[0].url} alt={`${currentTrack.item.album.name} album cover`} className="trackImage" />
                                            <div className="trackText">
                                                <div className="trackName">{currentTrack.item.name}</div>
                                                <div className="trackArtists">
                                                    {currentTrack.item.artists
                                                        .map((a) => a.name)
                                                        .join(", ")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="trackProgressBackground">
                                            <div className="trackProgress" style={{ width: `${(currentTrack.progress_ms / currentTrack.item.duration_ms) * 100}%` }}></div>
                                        </div>
                                    </div>
                                </>
                                    : `${currentTrack.currently_playing_type}`
                                : "Nothing right now"}
                    </div>
                </div>
            </div>
        </div>
    );
}
